export default __webpack_public_path__ + "static/media/giftSucessIcon.bc82b50a.svg";